/*
  ALTTAN ACILAN PENCERE: ASAGI CEKEREK KAPATMA (yalnizca yeni tasarim)

  Yeni tasarimda telefondaki form pencereleri (masraf, is, not, gorev...)
  ekranin altindan kayarak acilan bir "sayfa" gibi duruyor (gorunumu
  styles/mobil-arayuz.css'te). Bu dosya ona parmakla asagi cekip kapatma
  hareketini ekliyor:

  - Pencere en ustteyken asagi cekilirse parmakla birlikte iner.
  - 120 pikselden fazla cekilip birakilirsa pencerenin kendi "Iptal /
    Kapat" dugmesine basilmis gibi kapanir; boyle bir dugme yoksa
    arkadaki perdeye dokunulmus sayilir. Kapanmazsa yerine geri doner.
  - Yazi alanlarinda (input, textarea, select) baslayan dokunus hic
    karismaz: metin secimi ve kaydirma bozulmasin.
*/

export const PENCERELER = [
  '.case-file-form', '.job-form-container', '.masraf-form-container', '.note-form-container',
  '.task-form', '.user-form', '.modal-content', '.job-list-detail-modal', '.kasa-pencere',
  '.kg-pencere', '.mv-belge-pencere',
].join(',');

const KAPAT_YAZILARI = /^(İptal|iptal|IPTAL|Kapat|kapat|KAPAT|Vazgeç|vazgeç|×|✕|✖|Close)$/;

const telefonMu = () =>
  window.innerWidth <= 768 || document.body.classList.contains('capacitor-native');

const kapat = (pencere) => {
  const dugme = [...pencere.querySelectorAll('button')].find((b) => KAPAT_YAZILARI.test((b.textContent || '').trim()))
    || pencere.querySelector('[aria-label="Kapat"], .close-button, .modal-close, .btn-close');
  if (dugme) { dugme.click(); return; }
  const perde = pencere.parentElement;
  if (perde) perde.dispatchEvent(new MouseEvent('click', { bubbles: true }));
};

let kuruldu = false;

export const altPencereyiBaslat = () => {
  if (kuruldu) return;
  kuruldu = true;

  let pencere = null;
  let y0 = 0;
  let x0 = 0;
  let dy = 0;
  let suruklen = false;

  document.addEventListener('touchstart', (e) => {
    pencere = null;
    if (!telefonMu() || e.touches.length !== 1) return;
    const hedef = e.target;
    if (!hedef || typeof hedef.closest !== 'function') return;
    if (hedef.closest('input, textarea, select, [contenteditable="true"]')) return;
    const p = hedef.closest(PENCERELER);
    if (!p || p.scrollTop > 0) return;
    pencere = p;
    y0 = e.touches[0].clientY;
    x0 = e.touches[0].clientX;
    dy = 0;
    suruklen = false;
  }, { passive: true });

  document.addEventListener('touchmove', (e) => {
    if (!pencere) return;
    const t = e.touches[0];
    const d = t.clientY - y0;
    const dx = t.clientX - x0;
    if (!suruklen) {
      if (d > 8 && d > Math.abs(dx)) suruklen = true;
      else if (Math.abs(dx) > 8 || d < -4) { pencere = null; return; }
      else return;
    }
    dy = Math.max(0, d);
    if (e.cancelable) e.preventDefault();
    pencere.style.transition = 'none';
    pencere.style.transform = `translateY(${dy}px)`;
  }, { passive: false });

  const bitti = () => {
    if (!pencere) return;
    const p = pencere;
    pencere = null;
    if (!suruklen) return;
    p.style.transition = 'transform 0.28s cubic-bezier(0.22, 1, 0.36, 1)';
    if (dy > 120) {
      p.style.transform = 'translateY(100%)';
      window.setTimeout(() => {
        kapat(p);
        // Kapanmadiysa (dugme bulunamadi) yerine don.
        window.setTimeout(() => { if (p.isConnected) p.style.transform = ''; }, 60);
      }, 180);
    } else {
      p.style.transform = '';
    }
    window.setTimeout(() => { if (p.isConnected) p.style.transition = ''; }, 320);
  };
  document.addEventListener('touchend', bitti, { passive: true });
  document.addEventListener('touchcancel', bitti, { passive: true });
};
